import chat from "./asset/chat.png";
import orbitVideo from "./asset/orbit.mp4";
import benefits from "./asset/benefits.png";
import fotoautomatica from "./asset/preview1.png";
import summary from "./asset/summary.mp4";
import calendar from "./asset/calendar.png";

const data = [
	{
		id: 1,
		num: "01",
		icon: "♥",
		title: "FOTOAUTOMATICA",
		description:
			"Fotoautomatica is a digital photobooth on your phone. Take classic photobooth-style photos, customize your background colour, and download your pictures to keep and share.",
		link: "https://photobooth-app-git-main-iqra-imrans-projects.vercel.app/",
		images: [{ url: fotoautomatica, altText: "Fotoautomatica image" }],
	},
	{
		id: 2,
		num: "02",
		icon: "♥",
		title: "INSIGHTALLY",
		description:
			"InsightAlly is an AI-powered platform designed to help businesses make smarter, faster decisions. I contributed to building tools that let users quickly extract insights, streamline operations, and break down technical barriers. From intelligent search capabilities to actionable dashboards, the platform empowers teams to transform complex data into clear, reliable answers—driving operational efficiency and informed strategy.",
		link: "https://www.insightally.ai/",
		images: [{ url: benefits, altText: "InsightAlly image" }],
	},
	{
		id: 3,
		num: "03",
		icon: "♠︎",
		title: "CALENDAR",
		description:
			"I've developed my own version of a calendar where you can plan out your day, week, and year. The Modern Calendar App is a user-friendly application designed to streamline your scheduling and organization needs. It offers a seamless and intuitive	experience with a React-based frontend and a powerful backend powered by Node.js, Express, and PostgreSQL.",
		link: "https://github.com/iqrasy/personal-calendar",
		images: [{ url: calendar, altText: "calendar main page" }],
	},
	{
		id: 4,
		num: "04",
		icon: "♦︎",
		title: "CHAT-GPT CLONE",
		description:
			"This project is a ChatGPT clone developed using the OpenAI API, specifically utilizing the 'gpt-3.5-turbo' model. It is implemented as a single-page React application, featuring user authentication and signup functionality powered by Auth0. Auth0 also provides conversation tracking capabilities, enabling seamless management of user interactions and chat history.",
		link: "https://github.com/iqrasy/ChatGPT-clone",
		images: [{ url: chat, altText: "chat page" }],
	},
	{
		id: 5,
		num: "05",
		icon: "♣︎",
		title: "THE GIST",
		description:
			"I built a web app, The Gist, that takes any article and instantly turns it into a simple, easy-to-read summary. It’s powered by ChatGPT-4, with a frontend built in React and Redux. What really makes it stand out is the UI. I went for a cyberpunk vibe with minimal colors, wireframes, and a futuristic layout that makes the experience feel unique and engaging.",
		link: "https://github.com/iqrasy/AI-article-summarizer",
		// images: [{ url: thegist, altText: "The Gist" }],
		video: summary,
	},
	{
		id: 6,
		num: "06",
		icon: "♦︎",
		title: "ORBIT",
		description:
			"ORBIT is a project that aims to recreate the solar system using Three.js, a JavaScript library for 3D graphics. An immersive and visually stunning recreation of the solar system. As you explore, you'll be surrounded by a boundless ocean backdrop, accentuated by ethereal clouds that stretch endlessly. Prepare to embark on a captivating journey through space. It provides an interactive and visually appealing representation of the celestial bodies in our solar system.",
		link: "https://github.com/iqrasy/orbit",
		video: orbitVideo,
	},
];

export default data;
